import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../config/theme';
import { BRAND } from '../config/brand';

/**
 * Impaginazione comune delle pagine legali (Privacy, Termini, Cookie).
 * Le pagine sono pubbliche e vengono stampate anche come PDF (frontend/public/docs/).
 */
export const LEGAL_REVISION = 'Rev. 01';
export const LEGAL_DATE = '22/10/2026';
export const PLATFORM_URL = 'https://motoregareds.it';

export const LegalSection = ({ title, children }) => (
  <section className="space-y-2 legal-section">
    <h2 className="font-display text-xl font-medium pt-2" style={{ color: COLORS.text }}>
      {title}
    </h2>
    {children}
  </section>
);

export const LegalSubsection = ({ title }) => (
  <h3 className="text-base font-semibold pt-1" style={{ color: COLORS.text }}>
    {title}
  </h3>
);

export const OwnerBlock = () => (
  <p>
    {BRAND.legalName}
    <br />
    Sede legale: {BRAND.address}
    <br />
    Partita IVA: {BRAND.vatNumber}
    <br />
    Telefono: {BRAND.phone}
    <br />
    E-mail: {BRAND.privacyEmail}
  </p>
);

const LegalPage = ({ title, subtitle, children }) => {
  const logoUrl = `${process.env.PUBLIC_URL || ''}/logo.svg`;

  return (
    <div className="min-h-screen legal-page" style={{ backgroundColor: COLORS.bg }}>
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-10">
        <div className="flex justify-center mb-8">
          <img src={logoUrl} alt={`${BRAND.productName} - ${BRAND.companyName}`} className="h-16 w-auto" />
        </div>
        <div className="flex items-start justify-between gap-4 mb-6">
          <div>
            <h1 className="font-display text-3xl font-medium" style={{ color: COLORS.text }}>
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm mt-2" style={{ color: COLORS.text2 }}>
                {subtitle}
              </p>
            )}
            <p className="text-sm mt-1" style={{ color: COLORS.text2 }}>
              {LEGAL_REVISION} &ndash; {LEGAL_DATE} &middot; {BRAND.productName} &middot;{' '}
              {PLATFORM_URL.replace('https://', '')}
            </p>
          </div>

          <Link
            to="/login"
            className="legal-back inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold border hover:bg-white whitespace-nowrap"
            style={{ borderColor: COLORS.border, color: COLORS.text }}
          >
            Torna al login
          </Link>
        </div>

        <div
          className="bg-white border rounded-2xl p-6 md:p-8 shadow-sm space-y-6 leading-relaxed"
          style={{ borderColor: COLORS.border, color: '#2A3B52' }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
